<div class="table-responsive" *ngIf="irsaliyeler">
  <table class="table card-table table-vcenter text-nowrap datatable">
    <thead>
      <tr>
        <th class="w-1">Talep No</th>
        <th>Talep Tarihi</th>
        <th>Şube Adı</th>
        <th>Talep Türü</th>
        <th>Ürün Grubu</th>
        <th>Firma</th>
        <th>İrsaliye No</th>
        <th>Onay Durum</th>
        <th>Talep Oluşturan</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let s of irsaliyeler">
        <!-- <td><span class="text-muted">{{s.id}}</span></td> -->
        <td>{{s.siparis.talep?.talepNo}}</td>
        <td>{{s.siparis.talep?.olusturmaTarihi}}</td>
        <td>{{s.siparis.talep?.sube?.isim}}</td>
        <td>{{s.siparis.talep?.talepTur?.isim}}</td>
        <td>{{s.siparis.talep?.urunGrup?.isim}}</td>
        <td>{{s.siparis.cari?.firmaUnvani}}</td>
        <td>{{s.irsaliyeNo}}</td>
        <td>{{s.durumText}}</td>
        <td>{{s.siparis.talep?.kullanici?.adSoyad}}</td>
        <td class="text-right">
          <div class="btn btn-sm btn-success mr-3" *ngIf="!s.netsisIslendi" (click)="netsisAktar(s.id)">Netsise Aktar
          </div>
          <div class="btn btn-sm btn-primary" (click)="incele(s)">İncele</div>
        </td>
      </tr>
    </tbody>
  </table>
</div>